// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "b3bfba49bf8977132415bc474644bb8b" + ".js";
};